module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAQAAAAmTKJWAAAAzklEQVR4Ae3WAQYCARBA0UgKQF23OkQRkS6wLEBZCEh7md0j/LAIC/MNgvkAjAdmzKKKV1VVxZaGgQur8MSaCwMNW4/dmepiHCs6pq4e+8CPExS8PXaECDejYO+xJW2Em1EtSycJzlOey1OW85TnDJXnFJXnBJXmHjwEleY85TlP5TlP/Q/zlOc8Zbk89eSZ4PRSr3klOHuuBJelBJelLJenPOcpy+Upz/lXLsgdPNbPqCjXe+w2o6Lc3WM7WkZOExWJDWdGGnZxpaqqqvoCYvkZbeJ+VqEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/Close.png
// module id = 352
// module chunks = 0